import styled, { css } from 'styled-components';

export const Wapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 32px;
  padding: 80px 20px 32px 20px;
  background-color: #FCFCFC;
  
  @media only screen and (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const Button = styled.button`
  border: 2px solid #CCCCCC;
  color: #434343;
  height: 72px;
  border-radius: 20px;
  padding: 14px 0;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ checked }) => checked && css`
    border-color: #326CF9;
    background-color: #EEF8FF;
  `}
`;

export const Icon = styled.img`
  width: 44px;
  height: 44px;
  margin-right: 20px;
`;
